import { post, downloadStreamFile } from './http'

// 获取课程列表
export const getCourseList = (data) => post('/api/meas/admin/teach/course/getCourseListByStudy', data)
// 获取课程顶部信息
export const getCourseTopInfo = (data) => post('/api/meas/admin/teach/course/getCourseTopInfo', data)
// 获取学员学习信息
export const getStudentStudyList = (data) => post('/api/meas/admin/teach/study/getStudentStudyList', data)
// 导出学员学习情况列表
export const exportStudentStudyList = (data, fileName) => downloadStreamFile('/api/meas/admin/teach/study/exportStudentStudyList', data, fileName)

// 获取考勤明细列表
export const getStudyDetailsByPeriod = (data) => post('/api/meas/admin/teach/study/getStudyDetailsByPeriod', data)
// 考勤打卡
export const saveCheckInfo = (data) => post('/api/meas/admin/teach/study/saveCheckInfo', data)

// 获取考勤列表 
export const getStudyListByPeriod = (data) => post('/api/meas/admin/teach/study/getStudyListByPeriod', data)
// 获取课时顶部信息
export const getCourseperiodTopInfo = (data) => post('/api/meas/admin/teach/courseperiod/getCourseperiodTopInfo', data)